import { Injectable } from '@angular/core';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { EXPORT_SCHEDULES } from 'shared/search/search-service-types';
import { Observable } from 'rxjs';

import { Config } from 'shared/config/env.config';
import { contentHeaders } from 'common/headers';
import {catchError} from 'rxjs/operators';


@Injectable()
export class ExportScheduleManagerSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = EXPORT_SCHEDULES;
  idField = 'itemId';

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/export-schedules/${brandId}`;
  }

  getQueryString(searchModel: SearchModel): string {
    const queryString: string =
      'page=' + searchModel.currentPage +
      '&perPage=' + searchModel.itemsPerPage;

    return queryString;
  }

  deleteItems(brandId: string, ids: Array<string>): Observable<any> {
    const body = JSON.stringify({
      data: {
        exportScheduleIds: ids,
      },
    });
    return this.delete(
      `${Config.API}/export-schedules/${brandId}/`,
      body,
      { headers: contentHeaders }
    )

      .pipe(catchError(this.handleError.bind(this)));
  }
}
